export const environment = {
  production: false,
  URL_GESTAO_FROTAS: 'https://tst-gestaodefrotas.sascar.com.br/',
  URL_CORPORATIVE_USERS:
    'https://hom-corporative-user-register.test.sascarapis.com.br/hom-corporative-user-register-corporative-user-register-crud',
  URL_KEYCLOAK: 'https://hom-iam.sascar.com.br/auth',
  REALM: 'user-auth-temp',
  CLIENT_ID: 'app-clients',
  URL_USER_PREFERENCES:
    'https://hom-sasweb2.test.sascarapis.com.br:443/hom-sasweb2-user-preferences',
  OTP_RESEND_MINUTES: 5,
};
